export function NotFound() {
  return (
    <div className="flex flex-col items-center gap-2 text-center">
      {/* `<h1>` et non `<h2>` (audit Impeccable, 2026-09-07) : c'est le titre
          de la page, et cette page n'en avait aucun — un lecteur d'écran ne
          pouvait pas l'annoncer (WCAG 2.1 AA, 1.3.1/2.4.6). Apparence
          INCHANGÉE, les classes sont identiques. */}
      <h1 className="text-xl font-semibold text-gray-900">Page introuvable</h1>
      <p className="text-sm text-gray-600">La page demandée n&apos;existe pas.</p>
    </div>
  );
}
